<i18n>
{
	"en": {
		"confirmOrderRemovalTransporter": "An order you want to remove has already been sent. You will need to contact the transporter to complete the removal. Are you sure you want to remove the selected orders?"
	},
	"no": {
		"confirmOrderRemovalTransporter": "Oppdraget du vil fjerne, er allerede sendt. Du må kontakte transportøren for å fullføre fjerningen. Er du sikker på at du vil fjerne de valgte oppdrag?"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:hasHeader="false"
		icon="cog"
		iconType="bp"
		width="480px"
		@ok="$emit('confirm')"
		@close="$emit('close')"
	>
		{{$t('confirmOrderRemovalTransporter')}}
	</t-dialog>
</template>

<script>
export default {
	name: 'ConfirmRemoveTransporterOrder',
	props: { isShown: Boolean },
};
</script>
